import React from "react";

const DeltaLine = ({ delta, minDelta, maxDelta }) => {
  const width = 80;  // Total width of the SVG
  const height = 12;  // Height of the SVG
  const zeroLine = width / 2;  // Middle of the SVG, representing zero

  // Normalize delta to fit within the range from -zeroLine to +zeroLine
  const normalizedDelta = (delta - minDelta) / (maxDelta - minDelta) * 2 - 1; // Normalize to range [-1, 1]
  const deltaLength = normalizedDelta * zeroLine;  // Scale normalized delta to the SVG width

  const color = delta > 0 ? 'var(--green)' : 'var(--red)';

  return (
    <svg width={width} height={height}>
      {/* Horizontal reference line at zero */}
      <line
        x1={0}
        x2={width}
        y1={height / 2}
        y2={height / 2}
        stroke="#e0e0e0"
        strokeWidth="2"
      />

      {/* Vertical line at zero, exactly halfway */}
      <line
        x1={zeroLine}
        x2={zeroLine}
        y1={0}
        y2={height}
        stroke="#b0b0b0"
        strokeWidth="1"
        strokeDasharray="2, 2"
      />

      {/* Delta line, starting from zero line for positive or negative deviation */}
      <line
        x1={delta > 0 ? zeroLine : zeroLine + deltaLength}
        x2={delta > 0 ? zeroLine + deltaLength : zeroLine}
        y1={height / 2}
        y2={height / 2}
        stroke={color}
        strokeWidth="4"
      />
    </svg>
  );
};


export default DeltaLine;